__turbopack_context__.v({
  "attrLabelMobile": "FranchiseCompareTable-module-scss-module__DGvl3q__attrLabelMobile",
  "attrList": "FranchiseCompareTable-module-scss-module__DGvl3q__attrList",
  "attrRow": "FranchiseCompareTable-module-scss-module__DGvl3q__attrRow",
  "attrRowLast": "FranchiseCompareTable-module-scss-module__DGvl3q__attrRowLast",
  "attrValue": "FranchiseCompareTable-module-scss-module__DGvl3q__attrValue",
  "container": "FranchiseCompareTable-module-scss-module__DGvl3q__container",
  "contextLinkMobile": "FranchiseCompareTable-module-scss-module__DGvl3q__contextLinkMobile",
  "dataCell": "FranchiseCompareTable-module-scss-module__DGvl3q__dataCell",
  "heading": "FranchiseCompareTable-module-scss-module__DGvl3q__heading",
  "headingMobile": "FranchiseCompareTable-module-scss-module__DGvl3q__headingMobile",
  "imageLink": "FranchiseCompareTable-module-scss-module__DGvl3q__imageLink",
  "imagePlaceholder": "FranchiseCompareTable-module-scss-module__DGvl3q__imagePlaceholder",
  "imageWrapper": "FranchiseCompareTable-module-scss-module__DGvl3q__imageWrapper",
  "labelCell": "FranchiseCompareTable-module-scss-module__DGvl3q__labelCell",
  "labelCol": "FranchiseCompareTable-module-scss-module__DGvl3q__labelCol",
  "labelHeaderCell": "FranchiseCompareTable-module-scss-module__DGvl3q__labelHeaderCell",
  "nameWrapper": "FranchiseCompareTable-module-scss-module__DGvl3q__nameWrapper",
  "navigation": "FranchiseCompareTable-module-scss-module__DGvl3q__navigation",
  "placeholder": "FranchiseCompareTable-module-scss-module__DGvl3q__placeholder",
  "productCol": "FranchiseCompareTable-module-scss-module__DGvl3q__productCol",
  "productHeaderCell": "FranchiseCompareTable-module-scss-module__DGvl3q__productHeaderCell",
  "productImage": "FranchiseCompareTable-module-scss-module__DGvl3q__productImage",
  "productName": "FranchiseCompareTable-module-scss-module__DGvl3q__productName",
  "productNameLink": "FranchiseCompareTable-module-scss-module__DGvl3q__productNameLink",
  "scrollWrapper": "FranchiseCompareTable-module-scss-module__DGvl3q__scrollWrapper",
  "srOnly": "FranchiseCompareTable-module-scss-module__DGvl3q__srOnly",
  "table": "FranchiseCompareTable-module-scss-module__DGvl3q__table",
});
